import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import OneColumnA from '../components/OneColumnA/OneColumnA';
import TwoColumn from '../components/TwoColumn/TwoColumn';

const About = () => {
    const listItems = [
      ['Holistic Development:', ' We believe in developing the whole person and not just the player.'], 
      ['Empathy:', ' We believe in compassion to support each other on and off the field.'], 
      ['Reflection:', ' We believe in reflection to improve our thinking and performance.'], 
      ['Agency:', ' We believe in providing space for self-discovery.'], 
      ['Balance & Well-being:', ' We believe in prioritize and maintaining a healthy balance between soccer, academics, and other areas of their lives.']
    ];
  return (
    <div>
    <Navbar />
      <div className="app__background-gy">
        <TwoColumn
          title="Our Journey"          
          subtitleOne="About Us"
          paragraphOne="We are a small town soccer club sharing and promoting how soccer involves 
        high level thinking and reflection. We want every child to realize being a true athlete 
        involves using your feet and not just your hands.
        "
          subtitleTwo="History"
          paragraphTwo="Soccer has been played in and around Orion since the 1970's. It wasn't until the mid to late 90's that Orion soccer started to take shape. By the early 2000's Orion and Sherrard joined forces to become what is now Orion Sherrard United Soccer Club"
        />

      </div>
    <div class="section__padding app__background">
        <OneColumnA
          titleA="Core Values"
          items={listItems}

        />
      </div>
    <Footer />
    </div>
  )
}

export default About